







































































































































































import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { BudgetLoanForecastForm } from '@/modules/budget/execution/loan/types/BudgetLoanForecastForm'
import { millisToYear, deepCopy, rounding, formatDigitReadability, formatMaxFloat, formatNumber } from '@/modules/budget/execution/loan/utils'
import { Vue, Component, Prop } from 'vue-property-decorator';
import moment from 'moment'
import { AgreementForm } from '../types/AgreementForm';
import { cloneDeep } from 'lodash';

interface ScheduleRow {
    year: number;
    leftPrincipal: number | null;
    paymentDate: number;
    inflowSum: number | null;
    repaymentSum: number | null;
    refundSum: number | null;
    unusedSum: number | null;
    dateBeg: number | null;
    dateEnd: number | null;
    daysCount: number | null;
    sumBase: number | null;
    interestSum: number | null;
    interestFactSum: number | null;
    copaymentSum: number | null;
}

interface EditDayCount {
    date: string;
    daysCount: number
}

@Component
export default class ForecastScheduleTab extends Vue {
    // #region Props
    @Prop({
        type: Number,
        required: false,
        default: null,
    })
    public readonly agreementId!: number | null;
    @Prop({
        type: Object,
        required: true
    })
    public readonly mainAgreement: any;
    @Prop({
        type: Object,
        required: true
    })
    public readonly NewItem!: AgreementForm;
    @Prop({
        type: String,
        required: true
    })
    public readonly currentMode!: string;

    @Prop({
        type: Boolean,
        required: true
    })
    public readonly isWriteAccess!: boolean;
    // #endregion

    // #region Data
    public scheduleData: ScheduleRow[] = [];
    public tempScheduleData: ScheduleRow[] = [];
    public progress = 100;
    public editMode = false;
    public readonly tableFields = [
        {
            key: "rowNumber",
            label: "№",
        },
        {
            key: "leftPrincipal",
            label: "Остаток основного долга на начало периода",
        },
        {
            key: "year",
            label: "Год",
        },
        {
            key: "paymentDate",
            label: "Дата платежа",
        },
        {
            key: "inflowSum",
            label: "Cумма поступления",
        },
        {
            key: "repaymentSum",
            label: "Сумма погашения основного долга",
        },
        {
            key: "refundSum",
            label: "Сумма досрочного погашения",
        },
        {
            key: "unusedSum",
            label: "Сумма возврата неиспользованных средств",
        },
        {
            key: "dateBeg",
            label: "Начало периода начисления",
        },
        {
            key: "dateEnd",
            label: "Окончание периода начисления",
        },
        {
            key: "daysCount",
            label: "Кол-во дней",
        },
        {
            key: "sumBase",
            label: "Базовая сумма для начисления вознаграждения",
        },
        {
            key: "interestSum",
            label: "Сумма выплаты вознаграждения",
        },
        {
            key: "interestFactSum",
            label: "Сумма выплаты вознаграждения (факт)",
        },
        {
            key: "copaymentSum",
            label: "Сумма сопутствующих платежей",
        }
    ]
    // #endregion

    // #region LifeCycle
    private async created() {
        // Construct schedule data
        await this.constructForecastSchedule()
    }
    // #endregion

    // #region Methods
    public async generateNewForecastSchedule() {
        this.progress = 30
        try {
            const response = await fetch(`/api/budget-loan-schedule/payment-schedule-forecast/generate/${this.agreementId}`, {
                method: 'POST'
            })
            const data: BudgetLoanForecastForm[] = await response.json()
            this.progress = 80
            // const alteredRows = this.shiftInterestPeriodsScheduleRows(data)
            const scheduleRows = this.mapBudgetLoanForecastFormToSchedule(data)
            this.scheduleData = scheduleRows
            this.makeToast('Сгенерировано', 'Сообщение', 'success')
            this.$emit('reloadFact')
        } catch (error) {
            this.makeToast('Не удалось сгенерировать график', 'Ошибка', 'danger')
        } finally {
            this.progress = 100
        }
    }

    public async constructForecastSchedule() {
        this.progress = 30
        try {
            const response = await fetch(`/api/budget-loan-schedule/payment-schedule-forecast/get-data/${this.agreementId}`)
            const data: BudgetLoanForecastForm[] = await response.json()
            this.progress = 80
            // const alteredRows = this.shiftInterestPeriodsScheduleRows(data)
            this.scheduleData = this.mapBudgetLoanForecastFormToSchedule(data)
        } catch (error) {
            
        } finally {
            this.progress = 100
        }
    }

    public async getForecastScheduleWithDayCountCorrection(dayCountCorrections: EditDayCount[]) {
        this.progress = 30
        try {
            const response = await fetch(`/api/budget-loan-schedule/payment-schedule-forecast/get-data-with-correct/${this.agreementId}`, {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(dayCountCorrections)
            })
            const data: BudgetLoanForecastForm[] = await response.json()
            this.progress = 80
            // const alteredRows = this.shiftInterestPeriodsScheduleRows(data)
            this.scheduleData = this.mapBudgetLoanForecastFormToSchedule(data)
            this.makeToast('Редактирование применено', 'Сообщение', 'success')
            this.$emit('reloadFact')
        } catch (error) {
            this.makeToast('Не удалось загрузить прогнозные данные', 'Ошибка', 'danger')
        } finally {
            this.progress = 100
        }
    }

    private mapBudgetLoanForecastFormToSchedule(data: BudgetLoanForecastForm[]) {
        return data
            .sort((a, b) => a.scheduleDate - b.scheduleDate)
            .map(item => {
                // TODO: Remove 'any' after task-7852 and task-7792 branches in prod 
                // const copayment: any = item.sumPenalty ?? null
                let copaymentSum: number | null = (item.sumPenaltyPrincipal??0) + (item.sumPenaltyInterest??0)
                copaymentSum = copaymentSum || null

                const row: ScheduleRow = {
                    year: this.millisToYear(item.scheduleDate),
                    leftPrincipal: item.principalBalance,
                    paymentDate: item.scheduleDate,
                    inflowSum: item.sumInflowForecast,
                    repaymentSum: item.sumPrincipalRepaymentForecast,
                    refundSum: item.sumRefund,
                    unusedSum: item.sumRepaymentUnused,
                    dateBeg: item.dateBeg,
                    dateEnd: item.dateEnd,
                    daysCount: item.dayCount,
                    sumBase: item.sumBase,
                    interestSum: item.sumInterestForecast,
                    interestFactSum: item.sumInterestFact,
                    copaymentSum: copaymentSum
                }
                return row
            })
    }

    /**
     * При закрытий периода возн. раньше срока, смещать строку с периодом на факт. дату закрытия
     */
    shiftInterestPeriodsScheduleRows(rows: BudgetLoanForecastForm[]): BudgetLoanForecastForm[] {
        const earliestDateStr = '01-01-0001'

        const initialDate = this.millisToDate(this.NewItem.initialInterestRepaymentDate??earliestDateStr)
        const interestPeriodRows = rows.filter(row => {
            if (this.toDateMilliseconds(row.scheduleDate) < this.toDateMilliseconds(initialDate)) {
                return false
            }

            const momentDate = moment(row.scheduleDate)

            const isInterestDate = (initialDate === this.millisToDate(row.scheduleDate))
            ||
            (
            momentDate.date() === (this.NewItem.followingInterestRepaymentDay ?? -1)
            && (momentDate.month()+1) === (this.NewItem.followingInterestRepaymentMonth ?? -1)
            )

            return isInterestDate
        })
        .sort((a, b) => this.toDateMilliseconds(a.scheduleDate) - this.toDateMilliseconds(b.scheduleDate))

        let alteredRows = cloneDeep(rows)
        interestPeriodRows.forEach(currentInterestPeriodRow => {
            const previousRows = interestPeriodRows
                .filter(it => this.toDateMilliseconds(it.scheduleDate) < this.toDateMilliseconds(currentInterestPeriodRow.scheduleDate))
                .sort((a, b) => this.toDateMilliseconds(a.scheduleDate) - this.toDateMilliseconds(b.scheduleDate))

            const previousRow: BudgetLoanForecastForm | null = previousRows[previousRows.length-1] ?? null
            const previousRowScheduleDate: string | number | null = previousRow?.scheduleDate ?? earliestDateStr

            const inbetweenPeriodsRows = rows.filter(row => {
                return this.toDateMilliseconds(previousRowScheduleDate) < this.toDateMilliseconds(row.scheduleDate)
                && this.toDateMilliseconds(row.scheduleDate) < this.toDateMilliseconds(currentInterestPeriodRow.scheduleDate)
            })

            const fullyPaidInterestRow = inbetweenPeriodsRows.find(row => (row.sumInterestFact??0) >= (currentInterestPeriodRow.sumInterestForecast??0))
            if (fullyPaidInterestRow) {
                let shouldRemoveRow = false
                alteredRows.forEach(row => {
                    if (this.toDateMilliseconds(row.scheduleDate) === this.toDateMilliseconds(fullyPaidInterestRow.scheduleDate)) {
                        row.sumInterestForecast = currentInterestPeriodRow.sumInterestForecast
                        row.dateBeg = currentInterestPeriodRow.dateBeg
                        row.dateEnd = currentInterestPeriodRow.dateEnd
                        row.dayCount = currentInterestPeriodRow.dayCount
                        row.sumBase = currentInterestPeriodRow.sumBase
                        shouldRemoveRow = true
                    }
                })
                if (shouldRemoveRow) {
                    alteredRows = alteredRows.filter(row => {
                        // Если в строке периода возн. есть другие значения по мимо возн. то оставлять строку
                        if (this.millisToDate(row.scheduleDate) === this.millisToDate(currentInterestPeriodRow.scheduleDate)) {
                            if (
                                row.sumInflowForecast
                                || row.sumPrincipalRepaymentForecast
                                || row.sumPenaltyInterest
                                || row.sumPenaltyPrincipal
                                || row.sumRefund
                                || row.sumRepaymentUnused
                            ) {
                                // TODO: Убрать заглушки после мержда задачи 7852
                                // @ts-ignore
                                row.sumInterestForecast = null
                                // @ts-ignore
                                row.dateBeg = null
                                // @ts-ignore
                                row.dateEnd = null
                                // @ts-ignore
                                row.dayCount = null
                                // @ts-ignore
                                row.sumBase = null
                                return true
                            } else {
                                return false
                            }
                        }
                        return true
                    })
                }
            }
        })

        return alteredRows
    }

    toDateMilliseconds(date: Date | number | string): number {
        return moment(date).startOf('day').valueOf()
    }

    public async handleSaveEdited() {
        const edited: EditDayCount[] = this.scheduleData
            .filter(item => item.daysCount == 0 || item.daysCount)
            .map(item => {
                return {
                    date: this.toYYYYMMDDformat(item.paymentDate), // @ts-ignore
                    daysCount: parseInt(item.daysCount!!)
                }
            })
        const initial: EditDayCount[] = this.tempScheduleData
            .filter(item => item.daysCount == 0 || item.daysCount)
            .map(item => {
                return {
                    date: this.toYYYYMMDDformat(item.paymentDate), // @ts-ignore
                    daysCount: parseInt(item.daysCount!!)
                }
            })

        const payload: EditDayCount[] = []
        initial.forEach(initialItem => {
            const correspondingEditedItem = edited.find(editedItem => editedItem.date === initialItem.date)
            if (correspondingEditedItem && correspondingEditedItem?.daysCount !== initialItem.daysCount) {
                payload.push({
                    date: correspondingEditedItem.date,
                    daysCount: correspondingEditedItem.daysCount
                })
            }
        })
        if (payload.length > 0) {
            await this.getForecastScheduleWithDayCountCorrection(payload)
        }
        this.tempScheduleData = []
        this.editMode = false
    }

    public handleDayCountChange(value: number, index: number) {
        this.scheduleData[index]['daysCount'] = value
    }

    private makeToast(message: string, title: string, variant: 'success' | 'danger') {
        this.$bvToast.toast(message, {
            title: title,
            variant: variant,
            solid: true,
        })
    }

    public calculateTotal(scheduleData: ScheduleRow[], column: keyof ScheduleRow) {
        let total = 0
        scheduleData.forEach((item) => {
            if (item[column]) {
                total += (item[column]??0)
            }
        })
        return total
    }

    openAdditionalsModal(action: string | null = null) {
        this.$emit('openAdditionalsModal', action)
    }

    goBack() {
        this.$router.back()
    }

    toggleEditMode(isEnabled: boolean | null = null) {
        if (isEnabled === null) {
            this.editMode = !this.editMode
        } else {
            this.editMode = isEnabled
        }
        
        if (this.editMode) {
            this.tempScheduleData = this.deepCopy(this.scheduleData)
        } else {
            this.scheduleData = this.tempScheduleData
        }
    }
    // #endregion

    public toYYYYMMDDformat(date: number | string | Date) {
        if (!date) {
            return ''
        }
        const formatted = moment(date).format('YYYY-MM-DD')
        return formatted
    }
    public millisToDate(date: number | string | Date): string {
        if (!date) {
            return ''
        }
        const formatted = moment(date).format('DD-MM-YYYY')
        return formatted 
    }
    // #region Import declarations
    millisToYear = millisToYear
    rounding = rounding
    formatDigitReadability = formatDigitReadability
    formatMaxFloat = formatMaxFloat
    formatNumberCombined = formatNumber
    deepCopy = deepCopy
    // #endregion
}
